import { Request, Response } from "express"

import { getShoppingList } from "#services/user/shoppingList"

export const shoppingList = async (req: Request, res: Response) => {
	const list = await getShoppingList({ userID: req.params.userID })

	res.json(list)
}
